/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React, { useState } from 'react';
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import { Modal } from 'react-bootstrap';
import { TextField, Button, Grid, CircularProgress, Box, Tooltip, InputAdornment, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import Swal from 'sweetalert2';
import InfoIcon from '@mui/icons-material/Info'; // Import an MUI icon
import { variables } from '../components/Variables';
import { useStateContext } from '../contexts/ContextProvider';

const options = {
  Keep_upon_receipt: [
    { value: 'YES', label: 'YES' },
    { value: 'NO', label: 'NO' },
  ],
  SizeCategory: [
    { value: 'Small', label: 'Small' },
    { value: 'Large', label: 'Large' },
  ],
  Under_max_inventory_level: [
    { value: 'y/n', label: 'y/n' },
    { value: 'NA', label: 'NA' },
    // { value: 'NA', label: 'NA' },
  ],
  Pass_visual_inspection: [
    { value: 'y/n', label: 'y/n' },
    { value: 'NA', label: 'NA' },
    // { value: '', label: '' },
  ],
  Refurb_process_defined: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
    // { value: '', label: '' },
  ],
  Refurb_process_active: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
    // { value: '', label: '' },
  ],
  Receipt_reported_to_SimpliSafe: [
    { value: 'TRUE', label: 'TRUE' },
    { value: 'FALSE', label: 'FALSE' },
    // { value: '', label: '' },
  ],
  API_Integration: [
    { value: 'TRUE', label: 'TRUE' },
    { value: 'FALSE', label: 'FALSE' },
    // { value: '', label: '' },
  ],
  Quality_Testing_Program: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
  ],
  Sort_Criteria: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
  ],
  Like_New: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
  ],
  Tamper_Seal: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
  ],
  CCR: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    { value: 'NA', label: 'NA' },
  ],
  SerialNumberCaptureRequired: [
    { value: 'Y', label: 'Y' },
    { value: 'N', label: 'N' },
    // { value: 'NA', label: 'NA' },
  ],
};
const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 1300, // Increase z-index for the dropdown menu
  }),
};

const ItemMasterRowAdd = ({ tableData, runSKUTable }) => {
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit, setValue, reset, getValues } = useForm();
  const { show, setShow } = useStateContext();
  const LoginInfo = JSON.parse(localStorage.getItem('loginID')) || '';
  const handleClose = () => {
    setShow(false);
    reset();
    setValue('Description', '');
  };
  const handleClear = () => {
    reset();
  };
  const hasInsertItemMaster = LoginInfo.skuDetail?.some(
    (item) => item?.PageName === 'Insert Item Master',
  );

  const insertItemMaster = async (data) => {
    // debugger;
    setLoading(true);
    console.log(data.Inventory_target);
    const requestData = {
      UserId: LoginInfo.UserId,
      UserName: LoginInfo.UserName,
      ProcessName: LoginInfo.ProcessName,
      PageName: 'Insert Item Master',
      Action: 'AddNew',
      Item_ID: data.Item_ID,
      API_Integration: data.API_Integration?.value || '',
      Receipt_reported_to_SimpliSafe:
        data.Receipt_reported_to_SimpliSafe?.value || '',
      Description: data.Description || '',
      SimpliSafe_ERP_Certified_Item: data.SimpliSafe_ERP_Certified_Item || '',
      Keep_upon_receipt: data.Keep_upon_receipt?.value || '',
      SizeCategory: data.SizeCategory?.value || '',
      Under_max_inventory_level: data.Under_max_inventory_level?.value || '',
      Pass_visual_inspection: data.Pass_visual_inspection?.value || '',
      Refurb_process_defined: data.Refurb_process_defined?.value || '',
      Refurb_process_active: data.Refurb_process_active?.value || '',
      Inventory_target: data.Inventory_target || '',
      Quality_Testing_Program: data.Quality_Testing_Program?.value || '',
      Sort_Criteria: data.Sort_Criteria?.value || '',
      Like_New: data.Like_New?.value || '',
      Tamper_Seal: data.Tamper_Seal?.value || '',
      CCR: data.CCR?.value || '',
      TopChainSKU: data.TopChainSKU || '',
      SerialNumberCaptureRequired: data.SerialNumberCaptureRequired.value || '',
    };
    const config = {
      method: 'POST',
      url: `${variables.BASE_URL}InsertItemMaster`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: requestData,
    };
    try {
      const response = await axios(config);
      // console.log(response.data);
      if (response.data.IsSuccess) {
        // handleClose();
        Swal.fire({
          icon: 'success',
          title: 'Done',
          text: 'Successfully Added row.',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            handleClose();
            runSKUTable(); // function from ItemMaster component
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.Reason,
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };

  const handleShow = () => setShow(true);
  const onSubmit = async (data) => {
    // console.log('Form Values:', data);
    await insertItemMaster(data);
  };

  const checkTopchainSku = (value) => {
    const { Item_ID } = getValues();
    // console.log(Item_ID);
    // console.log('onBlur done', value);
    // console.log(tableData);
    const isItemIDMatch = tableData.some((item) => item.Item_ID === value);
    const isSameasItemId = Item_ID.toUpperCase() === value;
    // console.log(isItemIDMatch); // Now this will log the boolean result
    if (!(isItemIDMatch || isSameasItemId) && value !== '') {
      setValue('TopChainSKU', '');
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'The Top Chain SKU is not valid.',
        allowOutsideClick: false,
      });
      setTimeout(() => {
        document.getElementById('TopChainSKU_id').focus();
      }, 300);
    }
  };
  const checkItemId = (value) => {
    const isItemIDMatch = tableData.some((item) => {
      console.log(item.Item_ID.toUpperCase());
      return item.Item_ID.toUpperCase() === value;
    });
    // console.log(isItemIDMatch); // Now this will log the boolean result
    if (isItemIDMatch && value !== '') {
      setValue('Item_ID', '');
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'The Item ID is already present in Table.',
        allowOutsideClick: false,
      });
      setTimeout(() => {
        document.getElementById('Item_ID_id').focus();
      }, 300);
    }
  };
  const inventoryTooltip = (
    <div>
      <div>Blank / Empty value means there is no inventory target.</div>
      <div style={{ marginTop: 4 }}>
        <strong>0</strong> represents auto scrap because the inventory target has been reached.
      </div>
    </div>
  );
  return (
    <>
      {/* Button to Open Modal */}
      {hasInsertItemMaster ? (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleShow}
          sx={{ marginLeft: '30px' }}
        >
          Add New Row
        </Button>
      ) : null}

      {/* Modal */}
      <Modal
        className="myModal"
        show={show}
        backdrop="static"
        dialogClassName="modal-70w" // Custom class for 70% width modal
        aria-labelledby="example-custom-modal-styling-title"
        onHide={handleClose}
        keyboard={false}
        enforceFocus={false} // Prevents closing on focus loss
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Row for Item Master</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Controller
                  name="API_Integration"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ marginBottom: '16px' }}>
                      {/* <label>API_Integration</label> */}
                      <Select
                        {...field}
                        options={options.API_Integration}
                        placeholder="Select API Integration"
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Receipt_reported_to_SimpliSafe"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ marginBottom: '16px' }}>
                      {/* <label>Receipt_reported_to_SimpliSafe</label> */}
                      <Select
                        {...field}
                        options={options.Receipt_reported_to_SimpliSafe}
                        placeholder="Select Receipt reported to SimpliSafe"
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Item_ID"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      autoComplete="off"
                      id="Item_ID_id"
                      required
                      size="small"
                      {...field}
                      label="Item_ID"
                      fullWidth
                      margin="normal"
                      style={{ marginTop: '-1px' }}
                      onBlur={(e) => {
                        field.onBlur(); // Call the onBlur handler from react-hook-form
                        checkItemId(e.target.value.toUpperCase()); // Custom onBlur function
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Description"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      autoComplete="off"
                      required
                      size="small"
                      {...field}
                      label="Description"
                      fullWidth
                      margin="normal"
                      style={{ marginTop: '-1px' }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="SimpliSafe_ERP_Certified_Item"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      autoComplete="off"
                      size="small"
                      {...field}
                      label="SimpliSafe ERP Certified Item"
                      fullWidth
                      margin="normal"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3} className="mt-3">
                {/* React-Select Dropdowns */}
                <Controller
                  name="Keep_upon_receipt"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Keep_upon_receipt}
                        placeholder="Select Keep upon receipt*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3} className="mt-3">
                <Controller
                  name="SizeCategory"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.SizeCategory}
                        placeholder="Select Size Category*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3} className="mt-3">
                <Controller
                  name="Under_max_inventory_level"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Under_max_inventory_level}
                        placeholder="Select Under max inventory level*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>

              <Grid item xs={3}>
                <Controller
                  name="Pass_visual_inspection"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Pass_visual_inspection}
                        placeholder="Select Pass visual inspection*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Refurb_process_defined"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Refurb_process_defined}
                        placeholder="Select Refurb process defined*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Refurb_process_active"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Refurb_process_active}
                        placeholder="Select Refurb process active*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Inventory_target"
                  control={control}
                  defaultValue=""
                  rules={{
                    pattern: {
                      value: /^\d*$/, // Allows only positive numbers
                      message: 'Only positive numbers allowed',
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      autoComplete="off"
                      {...field}
                      size="small"
                      label="Inventory_target"
                      fullWidth
                      margin="normal"
                      style={{ marginTop: '-1px' }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (/^\d*$/.test(value)) {
                          field.onChange(value);
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Tooltip title={inventoryTooltip} arrow>
                              <IconButton>
                                <InfoIcon color="primary" fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Quality_Testing_Program"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Quality_Testing_Program}
                        placeholder="Select Quality Testing Program*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Sort_Criteria"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Sort_Criteria}
                        placeholder="Select Sort Criteria*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Like_New"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Like_New}
                        placeholder="Select Like New*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="Tamper_Seal"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.Tamper_Seal}
                        placeholder="Select Tamper Seal*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="CCR"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.CCR}
                        placeholder="Select CCR*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                        <p style={{ color: 'red', marginTop: '5px' }}>
                          {error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="TopChainSKU"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      autoComplete="off"
                      required
                      {...field} // Bind the field props correctly
                      size="small"
                      id="TopChainSKU_id"
                      onBlur={(e) => {
                        field.onBlur(); // Call the onBlur handler from react-hook-form
                        checkTopchainSku(e.target.value.toUpperCase()); // Custom onBlur function
                      }}
                      label="TopChainSKU"
                      fullWidth
                      margin="normal"
                      style={{ marginTop: '-1px' }} // for alighn with dropdown
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="SerialNumberCaptureRequired"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: 'This field is required', // Custom validation message
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <div style={{ marginBottom: '16px' }}>
                      <Select
                        {...field}
                        options={options.SerialNumberCaptureRequired}
                        placeholder="Select Serial# Capture Required*"
                        isClearable
                        styles={customStyles}
                      />
                      {error && (
                      <p style={{ color: 'red', marginTop: '5px' }}>
                        {error.message}
                      </p>
                      )}
                    </div>
                  )}
                />
              </Grid>
              {loading && <div className="fullscreen-overlay" /> ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    justifyItems: 'end',
                    marginTop: '100px',
                  }}
                >
                  <CircularProgress thickness={4} size={60} />
                </Box>
              ) : (
                <>
                  <Button variant="contained" type="submit" className="m-3" sx={{ height: '40px' }}>
                    Add Row
                  </Button>
                  <Button
                    sx={{ height: '40px' }}
                    variant="contained"
                    color="error" // This sets the button color to red
                    className="m-3"
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </>
              )}
            </Grid>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ItemMasterRowAdd;
